import { Agbalumo } from 'next/font/google'
import Image from 'next/image'
import Link from 'next/link'
export const agbalumo = Agbalumo({
  subsets: ['latin'],
  weight: ['400'],
})
export default function Logo({
  href,
  full,
}: {
  href?: string
  full?: boolean
}) {
  return (
    <Link href={href ? href : '/home'} className="">
      {!full ? (
        <Image width={54} height={54} src="/logo.png" alt="logo" />
      ) : (
        <div className="flex items-center gap-2">
          <Image width={54} height={54} src="/logo.png" alt="logo" />
          <span
            className={`block text-nowrap font-bold text-primary lg:text-lg`}
          >
            Cadence Calendar
          </span>
        </div>
      )}
    </Link>
  )
}

export function LogoWhite({ href }: { href?: string }) {
  return (
    <Link href={href ? href : '/home'} className="">
      <Image width={54} height={54} src="/logo.png" alt="logo" />
    </Link>
  )
}
